import React, { useRef } from 'react'
import { useDispatch } from 'react-redux'

/**
 * @typedef {Object} GlobalActionsDispatcherProps
 * @property {Element|JSX.Element} children
 */

/**
 * Component responsible of application global actions initialization.
 * @param {GlobalActionsDispatcherProps} props
 * @return {JSX.Element}
 */
export function GlobalActionsDispatcher({ children }) {
  const dispatch = useDispatch()

  /**
   * @type {React.MutableRefObject<Number>}
   */
  const prevState = useRef()

  return <>{children}</>
}
